<div class="grid">
    <div class="flex flex-column col-2 justify-content-center">
        <div class="property-name  justify-self-end">  <label
            [for]="'file-upload-logo'"
            class="p-button-secondary upload-logo">
            <i class="pi pi-pencil btn-hover cursor-pointer"></i>
        </label>
          <input
          type="file"
          [id]="'file-upload-logo'"
          class="upload-input"
          (change)="onLogoUpload($event)"
          [accept]="logoAttachmentTypes"
        />
        </div>
        <img alt="Company Logo"  class="align-self-center" *ngIf="company && ((company.image ?? '') !== '')" [src]="imageUrl" (error)="hideImage($event)" />
    </div>
    <div class="col-1"></div>
    <div class="col-2">
        <div class="property-name">Name</div>
        <div class="property-value">{{ company.name }}</div> 
        <div class="property-name">LLC Legal Name</div>
        <div class="property-value">{{ company.legalName }}</div> 
 
    </div>
    <div class="col-3">
        <div class="property-name">Stage</div>
        <div class="property-value">{{ company.stage }}</div> 
        <div class="property-name">Quantum Capital Member</div>
        <div class="property-value">{{ company.quantumCapitalMember }}</div> 

    </div>
    <div class="col-4">
        <div class="property-name"><span class="inline-block">Directors</span>
            <span class="ml-3" ><i [pTooltip]="infoMsg" class="pi pi-pencil cursor-pointer" (click)="editList()"></i></span>
        </div>
        <div class="chip-section">
            <div *ngFor="let member of company?.team?.boardMembers">
                <app-user-chip *ngIf="member" [userEmail]="member"></app-user-chip>
            </div>
        </div>
        <div class="property-name">Execution Team</div>
        <div class="chip-section">
            <div *ngFor="let member of company?.team?.executionTeam">
                <app-user-chip *ngIf="member" [userEmail]="member"></app-user-chip>
            </div>
        </div>
        <div class="property-name">Oversight Partner</div>
        <div class="chip-section">
            <div *ngFor="let member of company?.team?.oversightPartners">
                <app-user-chip *ngIf="member" [userEmail]="member"></app-user-chip>
            </div>
        </div>
        
    </div>
</div>


